const size = {
    xs: "550px",
    mobile: "764px",
    laptop: "1000px"
}

const breakpoints = {
    xs: `(max-width: ${size.xs})`,
    mobile: `(max-width: ${size.mobile})`,
    laptop: `(max-width: ${size.laptop})`,
}

export default breakpoints;